// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cards-container {
  container-type: inline-size;
}
.Cards-container .Cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5em;
}
@media (min-width: 768px) {
  .Cards-container .Cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 1200px) {
  .Cards-container .Cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
@media (min-width: 2000px) {
  .Cards-container .Cards {
    grid-template-columns: repeat(4, 1fr);
  }
}
@container (min-width: 768px) {
  .Cards-container .Cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
@container (min-width: 1200px) {
  .Cards-container .Cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
@container (min-width: 2000px) {
  .Cards-container .Cards {
    grid-template-columns: repeat(4, 1fr);
  }
}
.Card {
  display: flex;
  flex-flow: column nowrap;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0px 1px 5px 0px rgba(16, 24, 40, 0.1);
}
.Card > :first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.Card > :last-child {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.Card .CardMedia {
  position: relative;
  height: 0;
  padding-top: calc(56.25% / 2);
  padding-bottom: calc(56.25% / 2);
  text-align: center;
  color: #A4A7AE;
  background-color: #FAFAFA;
  overflow: hidden;
}
.Card .CardMedia.card-media-bg-contain img {
  object-fit: contain;
}
.Card .CardMedia .Video,
.Card .CardMedia img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.Card .CardMedia img {
  object-fit: cover;
}
.Card .CardHeader,
.Card .CardMain,
.Card .CardFooter {
  padding: 1em 1.5em;
}
.Card .CardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5em;
}
.Card .CardHeader h5 {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: 1rem;
}
.Card .CardHeader + .CardMain {
  padding-top: 0;
}
.Card .CardMain {
  flex: 1;
}
.Card .CardFooter {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1.5em;
  border-top: 1px solid #E9EAEB;
}
@media (min-width: 768px) {
  .Card .PageRow {
    gap: 0;
    margin: -1em -1.5em;
  }
  .Card .PageRow .PageCol {
    padding: 0.5em 1.5em;
  }
  .Card .PageRow .PageCol + .PageCol {
    border-left: 1px solid #E9EAEB;
  }
}
/*# sourceMappingURL=Cards.css.map */`, "",{"version":3,"sources":["webpack://./Cards.less","webpack://./wp_components/Cards/Cards.less"],"names":[],"mappings":"AAEA;EACI,2BAAA;ACDJ;ADAA;EAIQ,aAAA;EACA,0BAAA;EACA,UAAA;ACDR;ADGQ;EAAA;IACI,qCAAA;ECAV;AACF;ADEQ;EAAA;IACI,qCAAA;ECCV;AACF;ADCQ;EAAA;IACI,qCAAA;ECEV;AACF;ADAQ;EAAA;IACI,qCAAA;ECGV;AACF;ADDQ;EAAA;IACI,qCAAA;ECIV;AACF;ADFQ;EAAA;IACI,qCAAA;ECKV;AACF;ADAA;EACI,aAAA;EACA,wBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iDAAA;ACEJ;ADAI;EACI,4BAAA;EACA,6BAAA;ACER;ADCI;EACI,+BAAA;EACA,gCAAA;ACCR;ADfA;EAkBQ,kBAAA;EACA,SAAA;EACA,6BAAA;EACA,gCAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;ACAR;ADEQ;EAEQ,mBAAA;ACDhB;AD5BA;;EAmCY,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;ACHZ;ADpCA;EA2CY,iBAAA;ACJZ;ADvCA;;;EAkDQ,kBAAA;ACNR;AD5CA;EAsDQ,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;ACPR;ADlDA;EA4DY,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,SAAA;ACPZ;ADUQ;EACI,cAAA;ACRZ;AD3DA;EAwEQ,OAAA;ACVR;AD9DA;EA4EQ,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;ACXR;ADcI;EAAA;IAEQ,MAAA;IACA,mBAAA;ECZV;EDSE;IAMY,oBAAA;ECZd;EDcc;IACI,8BAAA;ECZlB;AACF;AACA,oCAAoC","sourcesContent":["@import '../../less/variables.less';\n\n.Cards-container {\n    container-type: inline-size;\n\n    .Cards {\n        display: grid;\n        grid-template-columns: 1fr;\n        gap: @element-margin;\n\n        @media (min-width: 768px) {\n            grid-template-columns: repeat(2, 1fr);\n        }\n\n        @media (min-width: 1200px) {\n            grid-template-columns: repeat(3, 1fr);\n        }\n\n        @media (min-width: 2000px) {\n            grid-template-columns: repeat(4, 1fr);\n        }\n\n        @container (min-width: 768px) {\n            grid-template-columns: repeat(2, 1fr);\n        }\n\n        @container (min-width: 1200px) {\n            grid-template-columns: repeat(3, 1fr);\n        }\n\n        @container (min-width: 2000px) {\n            grid-template-columns: repeat(4, 1fr);\n        }\n\n    }\n}\n\n.Card {\n    display: flex;\n    flex-flow: column nowrap;\n    background-color: @white;\n    border-radius: @radius-xl;\n    box-shadow: 0px 1px 5px 0px @box-shadow-color;\n\n    & > :first-child {\n        border-top-left-radius: @radius-xl;\n        border-top-right-radius: @radius-xl;\n    }\n\n    & > :last-child {\n        border-bottom-left-radius: @radius-xl;\n        border-bottom-right-radius: @radius-xl;\n    }\n\n    .CardMedia {\n        position: relative;\n        height: 0;\n        padding-top: calc(56.25% / 2); // 56.25% = 16:9 Aspect Ratio\n        padding-bottom: calc(56.25% / 2);\n        text-align: center;\n        color: @secondary-400;\n        background-color: @secondary-25;\n        overflow: hidden;\n\n        &.card-media-bg-contain {\n            img {\n                object-fit: contain;\n            }\n        }\n\n        .Video,\n        img {\n            position: absolute;\n            top: 0;\n            left: 0;\n            width: 100%;\n            height: 100%;\n        }\n\n        img {\n            object-fit: cover;\n        }\n    }\n\n    .CardHeader,\n    .CardMain,\n    .CardFooter {\n        padding: 1em 1.5em;\n    }\n\n    .CardHeader {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: @element-margin;\n\n        h5 {\n            display: flex;\n            flex-flow: row nowrap;\n            align-items: center;\n            gap: 1rem;\n        }\n\n        & + .CardMain {\n            padding-top: 0;\n        }\n    }\n\n    .CardMain {\n        flex: 1;\n    }\n\n    .CardFooter {\n        display: flex;\n        flex-flow: row wrap;\n        justify-content: space-between;\n        align-items: center;\n        gap: @element-margin;\n        border-top: 1px solid @separator-color;\n    }\n\n    @media (min-width: 768px) {\n        .PageRow {\n            gap: 0;\n            margin: -1em -1.5em;\n\n            .PageCol {\n                padding: 0.5em 1.5em;\n\n                & + .PageCol {\n                    border-left: 1px solid @separator-color;\n                }\n            }\n        }\n    }\n}",".Cards-container {\n  container-type: inline-size;\n}\n.Cards-container .Cards {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1.5em;\n}\n@media (min-width: 768px) {\n  .Cards-container .Cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@media (min-width: 1200px) {\n  .Cards-container .Cards {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@media (min-width: 2000px) {\n  .Cards-container .Cards {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n@container (min-width: 768px) {\n  .Cards-container .Cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n@container (min-width: 1200px) {\n  .Cards-container .Cards {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n@container (min-width: 2000px) {\n  .Cards-container .Cards {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}\n.Card {\n  display: flex;\n  flex-flow: column nowrap;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0px 1px 5px 0px rgba(16, 24, 40, 0.1);\n}\n.Card > :first-child {\n  border-top-left-radius: 12px;\n  border-top-right-radius: 12px;\n}\n.Card > :last-child {\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n.Card .CardMedia {\n  position: relative;\n  height: 0;\n  padding-top: calc(56.25% / 2);\n  padding-bottom: calc(56.25% / 2);\n  text-align: center;\n  color: #A4A7AE;\n  background-color: #FAFAFA;\n  overflow: hidden;\n}\n.Card .CardMedia.card-media-bg-contain img {\n  object-fit: contain;\n}\n.Card .CardMedia .Video,\n.Card .CardMedia img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.Card .CardMedia img {\n  object-fit: cover;\n}\n.Card .CardHeader,\n.Card .CardMain,\n.Card .CardFooter {\n  padding: 1em 1.5em;\n}\n.Card .CardHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1.5em;\n}\n.Card .CardHeader h5 {\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  gap: 1rem;\n}\n.Card .CardHeader + .CardMain {\n  padding-top: 0;\n}\n.Card .CardMain {\n  flex: 1;\n}\n.Card .CardFooter {\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1.5em;\n  border-top: 1px solid #E9EAEB;\n}\n@media (min-width: 768px) {\n  .Card .PageRow {\n    gap: 0;\n    margin: -1em -1.5em;\n  }\n  .Card .PageRow .PageCol {\n    padding: 0.5em 1.5em;\n  }\n  .Card .PageRow .PageCol + .PageCol {\n    border-left: 1px solid #E9EAEB;\n  }\n}\n/*# sourceMappingURL=Cards.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
